import { useState } from "react";
import { FaSearch } from "react-icons/fa";

const FloatingMenu = ({ menuItems }) => {
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  const handleItemClick = () => {
    setIsMenuVisible(false);
  };

  return (
    <div>
      {/* Floating Toggle Button */}
      <button
        onClick={toggleMenu}
        className="z-50 fixed bottom-8 right-2 p-3 bg-[#6cbb23] text-white rounded-full shadow-lg hover:bg-black hover:text-[#6cbb23] transition-all duration-300"
      >
        <FaSearch size={18} />
      </button>

    {/* Floating Menu */}
<div
  className={`z-50 fixed bottom-20 right-2 w-44 rounded-xl overflow-hidden shadow-2xl transition-all duration-300 ${
    isMenuVisible
      ? "opacity-100 scale-100 translate-y-0"
      : "opacity-0 scale-95 translate-y-4 pointer-events-none"
  }`}
>
  <ul className="bg-black text-white text-[12px] divide-y divide-gray-700 max-h-80 overflow-y-auto">
    {menuItems?.map((item, index) => (
      <li key={index}>
        <a
          href={item.href}
          onClick={handleItemClick}
          className="block px-3 py-2 hover:bg-gray-800 transition-colors duration-200"
        >
          {item.label}
        </a>
      </li>
    ))}
  </ul>
</div>
    </div>
  );
};

export default FloatingMenu;
